import { render, staticRenderFns } from "./ChipDropdown.vue?vue&type=template&id=1f2b0582&scoped=true&"
import script from "./ChipDropdown.vue?vue&type=script&lang=js&"
export * from "./ChipDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ChipDropdown.vue?vue&type=style&index=0&id=1f2b0582&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2b0582",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VBtn,VIcon,VList,VListItem,VMenu,VSubheader})
